import React from 'react';

/**
 * Wstrzykuje dane strukturalne do HTML-a strony.
 *
 * Skrypt jest renderowany w drzewie Reacta (a nie doklejany z useEffect),
 * dzieki czemu prerender zapisuje go do statycznego HTML-a i robot widzi
 * schema bez uruchamiania JavaScriptu.
 */
export default function JsonLd({ data }) {
  const nodes = Array.isArray(data) ? data : [data];
  return (
    <>
      {nodes.filter(Boolean).map((node, i) => (
        <script
          key={node['@id'] || `${node['@type']}-${i}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(node) }}
        />
      ))}
    </>
  );
}
